<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one" :style="slideStyle(0)">
        <div class="page">
          <h1>{{ slideTitle(0, "尚亚科技") }}</h1>
          <p>{{ slideSubtitle(0, "") }}</p>
        </div>
        <p class="slogan">{{ slideDescription(0, "立人立己 达人达己") }}</p>
        <div class="hero-actions">
          <router-link class="hero-action hero-action--primary" to="/product">探索产品中心</router-link>
          <router-link class="hero-action hero-action--ghost" to="/goin">了解尚亚科技</router-link>
        </div>
        <div class="hero-facts" aria-label="企业服务方向">
          <span>工程管理数字化</span><i></i><span>专业技术服务</span>
        </div>
        <div class="scroll-cue scroll-cue--mouse">
          <div class="mouse"></div>
          <p class="mousep">向下浏览</p>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two" :style="slideStyle(1)">
        <div class="page">
          <h2>{{ slideTitle(1, "产品样例与经典案例") }}</h2>
          <p>{{ slideSubtitle(1, "Successful Cases") }}</p>
        </div>
        <ul class="case-item">
          <li class="case-item__feature case-item__mall">
            <router-link
              class="case-card case-card--mall"
              to="/ganghaolai-mall"
              aria-label="查看刚好来商城产品详情"
            >
              <div class="case-card__img" :style="mallCardStyle"></div>
              <div class="case-card__info case-card__info--tall">
                <span class="case-card__badge">自营商城</span>
                <p class="case-card__title case-card__title--lg">刚好来商城</p>
                <p class="case-card__desc">自营超市为品质底座，连接本地优质商家，线上选购、到店自提、同城配送</p>
                <span class="case-card__action">
                  了解更多
                  <i class="el-icon-right" aria-hidden="true"></i>
                </span>
              </div>
            </router-link>
          </li>
          <li class="case-item__feature case-item__product">
            <router-link
              class="traffic-boost-promo feature-card feature-card--product"
              to="/traffic-boost"
              aria-label="查看重点产品流量速推详情"
            >
              <span class="traffic-boost-promo__eyebrow feature-card__eyebrow">重点产品</span>
              <i class="el-icon-data-analysis feature-card__icon" aria-hidden="true"></i>
              <strong>流量速推</strong>
              <p>让到店顾客成为内容传播节点</p>
              <span class="feature-card__action">
                查看产品详情
                <i class="el-icon-right" aria-hidden="true"></i>
              </span>
            </router-link>
          </li>
          <li
            v-for="(item,index) in featuredCases"
            :key="item.Id || index"
            class="case-item__case"
          >
            <router-link
              class="case-card"
              :to="{ name: 'casedetails', params: { id: item.Id }}"
            >
              <div class="case-card__img" v-lazy:background-image="imgserver + item.Img"></div>
              <div class="case-card__info">
                <p class="case-card__title">{{item.Title}}</p>
                <span class="case-card__more">
                  查看详情
                  <i class="el-icon-right" aria-hidden="true"></i>
                </span>
              </div>
            </router-link>
          </li>
        </ul>
        <router-link class="home-section-link" to="/case">查看全部案例 <i class="el-icon-right"></i></router-link>
        <div class="scroll-cue">
          <p class="mousep">向下浏览</p>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three" :style="slideStyle(2)">
        <div class="page honor-page-title">
          <h2>{{ slideTitle(2, "荣誉墙") }}</h2>
          <p>{{ slideSubtitle(2, "Honor Wall") }}</p>
        </div>
        <section
          class="honor-wall"
          aria-label="企业荣誉证书展示墙"
          @mouseenter="pauseHonorRotation"
          @mouseleave="startHonorRotation"
        >
          <div class="honor-wall__glow honor-wall__glow--left"></div>
          <div class="honor-wall__glow honor-wall__glow--center"></div>
          <div class="honor-wall__glow honor-wall__glow--right"></div>
          <div class="honor-wall__brand">
            <span>KEJIAN</span>
            <small>EXCELLENCE · RESPONSIBILITY · INNOVATION</small>
          </div>
          <div class="honor-wall__layout">
            <article
              v-for="frame in honorFrames"
              :key="frame.position"
              class="honor-frame"
              :class="[`honor-frame--${frame.orientation}`, `honor-frame--${frame.position}`]"
            >
              <transition name="certificate-fade" mode="out-in">
                <div :key="frame.item.id" class="honor-frame__content">
                  <div
                    v-if="frame.item.imageUrl"
                    class="honor-frame__image"
                    :style="certificateStyle(frame.item)"
                    role="img"
                    :aria-label="frame.item.title || '荣誉证书'"
                  ></div>
                  <div v-else class="honor-frame__placeholder">
                    <span class="honor-frame__seal">KJ</span>
                    <strong>荣誉证书</strong>
                    <small>{{ frame.orientation === "portrait" ? "PORTRAIT" : "LANDSCAPE" }}</small>
                    <i></i>
                  </div>
                  <div class="honor-frame__plate">{{ frame.item.title || "企业荣誉" }}</div>
                </div>
              </transition>
            </article>
          </div>
          <div class="honor-wall__counter">
            <span>{{ String((honorOffset % 12) + 1).padStart(2, "0") }}</span>
            <i></i>
            <small>12 HONORS</small>
          </div>
        </section>
        <div class="scroll-cue">
          <p class="mousep">向下浏览</p>
        </div>
      </swiper-slide>
      <div class="home-swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getDefaultSiteConfig, loadSiteConfig } from "../services/siteConfig";
import mallHomeImage from "../assets/img/ganghaolai-mall-home.jpg";
const { normalizeHonorWall, getVisibleHonorItems } = require("../services/honorWall");

// 首尾循环时要跨越整条轨道，用更快的速度避免"倒带"显得拖沓
const WRAP_SPEED = 620;

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [],
      siteConfig: getDefaultSiteConfig(),
      wheelLocked: false,
      wheelUnlockTimer: null,
      honorOffset: 0,
      honorRotationTimer: null,
      swiperOption: {
        notNextTick: true,
        direction: "vertical",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: 1,
        speed: 850,
        loop: false,
        allowTouchMove: window.innerWidth > 768,
        loopAdditionalSlides: 0,
        pagination: {
          el: ".home-swiper-pagination",
          clickable: true
        },
        height: window.innerHeight - (window.innerWidth <= 768 ? 56 : 72),
        resistanceRatio: 0,
        observer: true,
        observeParents: true,
        on: {}
      }
    };
  },
  computed: {
    featuredCases() {
      return Array.isArray(this.caseList) ? this.caseList.slice(0, 5) : [];
    },
    mallCardStyle() {
      return { backgroundImage: `url(${mallHomeImage})` };
    },
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null;
    },
    homeSlides() {
      return this.siteConfig.homeSlides || [];
    },
    honorWall() {
      return normalizeHonorWall(this.siteConfig.honorWall);
    },
    visibleHonorItems() {
      return getVisibleHonorItems(this.honorWall, this.honorOffset);
    },
    honorFrames() {
      const portraits = this.visibleHonorItems.portraits;
      const landscapes = this.visibleHonorItems.landscapes;
      return [
        { position: "portrait-left", orientation: "portrait", item: portraits[0] },
        { position: "landscape-left", orientation: "landscape", item: landscapes[0] },
        { position: "portrait-mid-left", orientation: "portrait", item: portraits[1] },
        { position: "landscape-main", orientation: "landscape", item: landscapes[1] },
        { position: "portrait-mid-right", orientation: "portrait", item: portraits[2] },
        { position: "landscape-right", orientation: "landscape", item: landscapes[2] },
        { position: "portrait-right", orientation: "portrait", item: portraits[3] }
      ];
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateSwiperHeight);
    this.$nextTick(this.bindHomeSwiperEvents);
    this.loadHomeConfig();
    this.$http
      .get("Cases/GetCasesAll")
      .then(response => {
        this.caseList = response.data;
      })
      .catch(() => {})
      .then(() => {
        this.loading = false;
      });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateSwiperHeight);
    this.unbindHomeSwiperEvents();
    clearTimeout(this.wheelUnlockTimer);
    clearInterval(this.honorRotationTimer);
  },
  methods: {
    loadHomeConfig() {
      loadSiteConfig()
        .then(config => {
          this.siteConfig = config;
          this.startHonorRotation();
          this.$nextTick(this.updateSwiperHeight);
        })
        .catch(() => {
          this.siteConfig = getDefaultSiteConfig();
          this.startHonorRotation();
        });
    },
    startHonorRotation() {
      clearInterval(this.honorRotationTimer);
      const delay = this.honorWall.rotationSeconds * 1000;
      this.honorRotationTimer = setInterval(() => {
        this.honorOffset = (this.honorOffset + 1) % 35;
      }, delay);
    },
    pauseHonorRotation() {
      clearInterval(this.honorRotationTimer);
      this.honorRotationTimer = null;
    },
    certificateStyle(item) {
      return item && item.imageUrl ? { backgroundImage: `url(${item.imageUrl})` } : {};
    },
    slideConfig(index) {
      return this.homeSlides[index] || {};
    },
    slideTitle(index, fallback) {
      return this.slideConfig(index).title || fallback;
    },
    slideSubtitle(index, fallback) {
      return this.slideConfig(index).subtitle || fallback;
    },
    slideDescription(index, fallback) {
      return this.slideConfig(index).description || fallback;
    },
    slideStyle(index) {
      const backgroundUrl = this.slideConfig(index).backgroundUrl;
      return backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : {};
    },
    getSwiperEl() {
      return this.$refs.mySwiper && this.$refs.mySwiper.$el;
    },
    bindHomeSwiperEvents() {
      const el = this.getSwiperEl();
      if (!el) return;
      el.addEventListener("wheel", this.handleHomeWheel, { passive: false });
      el.addEventListener("click", this.handleHomeCueClick);
      document.addEventListener("keydown", this.handleHomeKeydown);
    },
    unbindHomeSwiperEvents() {
      document.removeEventListener("keydown", this.handleHomeKeydown);
      const el = this.getSwiperEl();
      if (!el) return;
      el.removeEventListener("wheel", this.handleHomeWheel);
      el.removeEventListener("click", this.handleHomeCueClick);
    },
    handleHomeCueClick(event) {
      const target = event.target;
      if (!target || !target.closest || !target.closest(".scroll-cue")) return;
      if (this.isMobileViewport()) {
        const currentSlide = target.closest(".swiper-slide");
        const nextSelector = currentSlide && currentSlide.classList.contains("slide-one")
          ? ".slide-two:not(.swiper-slide-duplicate)"
          : ".slide-three:not(.swiper-slide-duplicate)";
        const nextSlide = document.querySelector(nextSelector);
        if (nextSlide && nextSlide.scrollIntoView) {
          nextSlide.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        return;
      }
      this.slideNext();
    },
    handleHomeKeydown(event) {
      if (this.isMobileViewport() || this.wheelLocked) return;
      const target = event.target;
      if (target && /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)) return;
      if (event.key === "ArrowDown" || event.key === "PageDown") {
        event.preventDefault();
        this.lockWheel();
        this.slideNext();
      } else if (event.key === "ArrowUp" || event.key === "PageUp") {
        event.preventDefault();
        this.lockWheel();
        this.slidePrev();
      }
    },
    handleHomeWheel(event) {
      if (this.isMobileViewport()) return;
      const delta = event.deltaY || -event.wheelDelta || event.detail;
      if (!delta) return;
      event.preventDefault();
      if (this.wheelLocked) return;
      this.lockWheel();
      if (delta > 0) {
        this.slideNext();
      } else {
        this.slidePrev();
      }
    },
    lockWheel() {
      this.wheelLocked = true;
      clearTimeout(this.wheelUnlockTimer);
      this.wheelUnlockTimer = setTimeout(() => {
        this.wheelLocked = false;
      }, this.swiperOption.speed + 180);
    },
    isMobileViewport() {
      return window.innerWidth <= 768;
    },
    updateSwiperHeight() {
      if (!this.isMobileViewport()) {
        this.swiperOption.height = window.innerHeight - 72;
      }
      this.$nextTick(() => {
        if (this.swiper && this.swiper.update) {
          this.swiper.update();
        }
      });
    },
    slideCount() {
      const swiper = this.swiper;
      return swiper && swiper.slides ? swiper.slides.length : 0;
    },
    slideToWrapped(index) {
      const swiper = this.swiper;
      if (swiper && swiper.slideTo) {
        swiper.slideTo(index, WRAP_SPEED);
      }
    },
    slideNext() {
      const swiper = this.swiper;
      if (!swiper) return;
      if (swiper.isEnd) {
        this.slideToWrapped(0);
      } else if (swiper.slideNext) {
        swiper.slideNext();
      }
    },
    slidePrev() {
      const swiper = this.swiper;
      if (!swiper) return;
      if (swiper.isBeginning) {
        this.slideToWrapped(Math.max(this.slideCount() - 1, 0));
      } else if (swiper.slidePrev) {
        swiper.slidePrev();
      }
    }
  }
};
</script>
 
<style lang="scss" scoped>
#swiperBox {
  position: relative;
}

.swiper-slide {
  position: relative;
  overflow: hidden;
}

.swiper-slide-active .page h1,
.swiper-slide-active .page h2,
.swiper-slide-active .page h3 {
  animation: homeTitleDrop 0.8s ease both;
}

.swiper-slide-active .page p {
  animation: homeTitleRise 0.8s ease 0.08s both;
}

.swiper-slide-active .slogan,
.swiper-slide-active .honor-wall {
  animation: homeFadeUp 0.9s ease 0.16s both;
}

.swiper-slide-active .hero-actions {
  animation: homeFadeUp 0.8s var(--ease-out) 0.32s both;
}

.swiper-slide-active .hero-facts {
  animation: homeFadeUp 0.8s var(--ease-out) 0.44s both;
}

/* Bento 卡片错峰入场，让第二屏从"一次性砸出来"变成有节奏地铺开 */
.swiper-slide-active .case-item li {
  animation: homeCardRise 0.72s var(--ease-out) both;
}

.swiper-slide-active .case-item li:nth-child(1) { animation-delay: 0.3s; }
.swiper-slide-active .case-item li:nth-child(2) { animation-delay: 0.37s; }
.swiper-slide-active .case-item li:nth-child(3) { animation-delay: 0.44s; }
.swiper-slide-active .case-item li:nth-child(4) { animation-delay: 0.51s; }
.swiper-slide-active .case-item li:nth-child(5) { animation-delay: 0.58s; }
.swiper-slide-active .case-item li:nth-child(6) { animation-delay: 0.65s; }
.swiper-slide-active .case-item li:nth-child(7) { animation-delay: 0.72s; }

.home-swiper-pagination {
  position: absolute;
  right: 24px;
  top: 50%;
  z-index: 20;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 竖向指示条：未选中是短线，选中拉长并转为金色，比圆点更克制也更有秩序感 */
.home-swiper-pagination ::v-deep .swiper-pagination-bullet,
.home-swiper-pagination ::v-deep .swiper-pagination-bullet {
  width: 3px;
  height: 18px;
  margin: 7px 0;
  opacity: 1;
  border: 0;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.42);
  transition: height var(--duration-base) var(--ease-out), background var(--duration-base) ease;
}

.home-swiper-pagination ::v-deep .swiper-pagination-bullet:hover,
.home-swiper-pagination ::v-deep .swiper-pagination-bullet:hover {
  background: rgba(255, 255, 255, 0.78);
}

.home-swiper-pagination ::v-deep .swiper-pagination-bullet-active,
.home-swiper-pagination ::v-deep .swiper-pagination-bullet-active {
  height: 38px;
  background: var(--accent-500);
  box-shadow: 0 0 16px rgba(213, 165, 82, 0.5);
}

.scroll-cue {
  position: absolute;
  left: 50%;
  bottom: 26px;
  z-index: 15;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(-50%);
  cursor: pointer;
  user-select: none;
}

.scroll-cue--mouse {
  bottom: 34px;
}

p.mousep {
  margin: 8px 0 0;
  color: #fff;
  font-family: "Microsoft YaHei", "Lantinghei SC", "Open Sans", Arial,
    "Hiragino Sans GB", "STHeiti", "WenQuanYi Micro Hei", "SimSun", sans-serif;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 12px;
  text-indent: 12px;
  animation: colorText 5s ease-out infinite, nudgeText 5s ease-out infinite;
}

.mouse {
  position: relative;
  width: 52px;
  height: 88px;
  margin: 0 auto;
  border-radius: 100px;
  background: #4e5559 linear-gradient(transparent 0%, transparent 50%, #fff 50%, #fff 100%);
  background-size: 225%;
  transform: scale(0.5);
  transform-origin: center bottom;
  animation: colorSlide 5s linear infinite, nudgeMouse 5s ease-out infinite;
}

.mouse:before,
.mouse:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.mouse:before {
  width: 46px;
  height: 82px;
  border-radius: 100px;
  background-color: #222a30;
}

.mouse:after {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #fff;
  animation: trackBallSlide 5s linear infinite;
}

@keyframes homeTitleDrop {
  from {
    opacity: 0;
    transform: translateY(-42px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes homeTitleRise {
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(36px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes homeCardRise {
  from {
    opacity: 0;
    transform: translateY(28px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes colorSlide {
  0% { background-position: 0% 100%; }
  20% { background-position: 0% 0%; }
  21% { background-color: #4e5559; }
  29.99% { background-color: #fff; background-position: 0% 0%; }
  30% { background-color: #4e5559; background-position: 0% 100%; }
  50% { background-position: 0% 0%; }
  51% { background-color: #4e5559; }
  59.99% { background-color: #fff; background-position: 0% 0%; }
  60% { background-color: #4e5559; background-position: 0% 100%; }
  80% { background-position: 0% 0%; }
  81% { background-color: #4e5559; }
  89.99%, 100% { background-color: #fff; }
}

@keyframes trackBallSlide {
  0%, 30%, 60% { opacity: 1; transform: scale(1) translateY(-20px); }
  6%, 36%, 66% { opacity: 1; transform: scale(0.9) translateY(5px); }
  14%, 44%, 74% { opacity: 0; transform: scale(0.4) translateY(40px); }
  15%, 19%, 45%, 49%, 75%, 79% { opacity: 0; transform: scale(0.4) translateY(-20px); }
  28%, 29.99%, 58%, 59.99%, 88%, 100% { opacity: 1; transform: scale(1) translateY(-20px); }
}

@keyframes nudgeMouse {
  0%, 30%, 60%, 90% { transform: scale(0.5) translateY(0); }
  20%, 50%, 80% { transform: scale(0.5) translateY(8px); }
}

@keyframes nudgeText {
  0%, 30%, 60%, 90% { transform: translateY(0); }
  20%, 50%, 80% { transform: translateY(2px); }
}

@keyframes colorText {
  21%, 51%, 81% { color: rgba(255, 255, 255, 0); }
  30%, 60%, 90% { color: #fff; }
}

/* .el-header {
  position: absolute;
} */
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h1,
    h2,
    h3 {
      font-size: 34px;
      font-weight: 500;
      color: #fff;
    }

    p {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.82);
    }
  }

  .slogan {
    text-align: center;
    font-size: 40px;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例 - Bento 网格
.case-item {
  width: min(1120px, calc(100vw - 48px));
  height: 520px;
  margin: 26px auto 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 14px;
  list-style: none;

  li {
    position: relative;
    overflow: hidden;
    list-style: none;
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-md);
    box-shadow: 0 14px 38px rgba(3, 22, 36, 0.28);
    transition: transform 0.35s var(--ease-out), box-shadow 0.35s ease, border-color 0.35s ease;

    &:hover {
      transform: translateY(-4px);
      border-color: rgba(255, 255, 255, 0.3);
      box-shadow: 0 22px 52px rgba(3, 22, 36, 0.4);
    }
  }
}

.case-item__mall {
  grid-column: 1;
  grid-row: 1 / -1;
}

.case-item__product {
  grid-column: 2;
  grid-row: 1 / -1;
  background:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(168deg, var(--brand-700) 0%, var(--brand-950) 100%);
  background-size: 28px 28px, 28px 28px, auto;
}

//特色竖卡（商城 / 产品）
.feature-card {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 26px 24px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  overflow: hidden;
  color: #fff;
  text-decoration: none;
}

.feature-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 96px;
  height: 4px;
}

.feature-card--product::before {
  background: var(--accent-300);
}

.feature-card__eyebrow {
  position: absolute;
  top: 20px;
  left: 22px;
  padding: 5px 10px;
  border: 1px solid rgba(255, 255, 255, 0.34);
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.feature-card__icon {
  position: absolute;
  top: 24px;
  right: 22px;
  font-size: 40px;
}

.feature-card--product .feature-card__icon {
  color: var(--accent-300);
}

.feature-card strong {
  font-size: 26px;
  line-height: 1.25;
  letter-spacing: 0.02em;
}

.feature-card > p {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 13px;
  line-height: 1.65;
}

.feature-card__action {
  display: inline-flex;
  margin-top: 18px;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 700;
  transition: gap 0.25s ease;
}

.feature-card--product .feature-card__action {
  color: var(--accent-300);
}

.feature-card:hover .feature-card__action {
  gap: 12px;
}

.feature-card:focus-visible {
  outline: 3px solid #fff;
  outline-offset: -6px;
}

//案例卡片
.case-card {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-decoration: none;
}

.case-card__img {
  position: absolute;
  inset: 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transition: transform 0.6s var(--ease-out);
}

.case-card:hover .case-card__img {
  transform: scale(1.04);
}

.case-card__info {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  padding: 38px 16px 14px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  background: linear-gradient(180deg, transparent 0%, rgba(6, 30, 46, 0.88) 82%);
  transition: background 0.4s ease;
}

.case-card:hover .case-card__info {
  background: linear-gradient(180deg, rgba(6, 30, 46, 0.1) 0%, rgba(6, 30, 46, 0.94) 68%);
}

.case-card__title {
  width: 100%;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.case-card__more {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 12px;
  letter-spacing: 0.06em;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.35s ease, transform 0.35s var(--ease-out);
}

.case-card:hover .case-card__more {
  opacity: 1;
  transform: translateY(0);
}

//刚好来商城竖卡
.case-card--mall .case-card__info--tall {
  padding: 56px 18px 20px;
  gap: 8px;
  background: linear-gradient(
    180deg,
    rgba(6, 30, 46, 0.18) 0%,
    transparent 26%,
    rgba(6, 30, 46, 0.94) 82%
  );
}

.case-card--mall:hover .case-card__info--tall {
  background: linear-gradient(
    180deg,
    rgba(6, 30, 46, 0.28) 0%,
    rgba(6, 30, 46, 0.1) 26%,
    rgba(6, 30, 46, 0.96) 74%
  );
}

.case-card__badge {
  align-self: flex-start;
  padding: 4px 10px;
  border: 1px solid rgba(240, 207, 140, 0.66);
  border-radius: 999px;
  color: var(--accent-300);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.case-card__title--lg {
  font-size: 21px;
  white-space: nowrap;
}

.case-card__desc {
  color: rgba(255, 255, 255, 0.74);
  font-size: 12px;
  line-height: 1.6;
}

.case-card__action {
  display: inline-flex;
  margin-top: 4px;
  align-items: center;
  gap: 6px;
  color: var(--accent-300);
  font-size: 13px;
  font-weight: 700;
  transition: gap 0.25s ease;
}

.case-card--mall:hover .case-card__action {
  gap: 11px;
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}
//荣誉墙
.honor-page-title {
  position: relative;
  z-index: 5;
  height: 82px !important;

  h1,
    h2,
    h3 { letter-spacing: 8px; }
  p {
    margin-top: 4px;
    font-size: 18px !important;
    letter-spacing: 7px;
    color: rgba(255, 255, 255, 0.64) !important;
  }
}

.honor-wall {
  position: relative;
  width: calc(100% - 150px);
  max-width: 1180px;
  height: 55vh;
  min-height: 400px;
  max-height: 510px;
  margin: 12px auto 0;
  overflow: hidden;
  border: 1px solid rgba(218, 188, 118, 0.35);
  border-radius: 3px;
  background:
    linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.025) 50%, transparent 100%),
    radial-gradient(circle at 50% 42%, rgba(52, 79, 96, 0.54), transparent 47%),
    linear-gradient(135deg, #13232e 0%, #0b171f 52%, #10232d 100%);
  box-shadow: inset 0 0 80px rgba(0, 0, 0, 0.55), 0 24px 70px rgba(0, 0, 0, 0.28);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    opacity: 0.23;
    background-image:
      linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.018) 1px, transparent 1px);
    background-size: 44px 44px;
  }

  &::after {
    content: "";
    position: absolute;
    left: 3%;
    right: 3%;
    bottom: 4.5%;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(220, 187, 111, 0.58), transparent);
  }
}

.honor-wall__brand {
  position: absolute;
  left: 50%;
  top: 5.5%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgba(230, 211, 166, 0.68);
  transform: translateX(-50%);

  span {
    font-family: Georgia, "Times New Roman", serif;
    font-size: 19px;
    letter-spacing: 8px;
  }

  small {
    margin-top: 4px;
    font-size: 7px;
    letter-spacing: 2.6px;
    color: rgba(255, 255, 255, 0.28);
  }
}

.honor-wall__glow {
  position: absolute;
  top: -18%;
  width: 24%;
  height: 76%;
  pointer-events: none;
  opacity: 0.4;
  background: linear-gradient(180deg, rgba(255, 238, 184, 0.3), transparent 72%);
  clip-path: polygon(44% 0, 56% 0, 100% 100%, 0 100%);

  &--left { left: 7%; transform: rotate(5deg); }
  &--center { left: 38%; width: 28%; }
  &--right { right: 5%; transform: rotate(-5deg); }
}

.honor-wall__layout {
  position: absolute;
  inset: 0;
  z-index: 3;
}

.honor-frame {
  position: absolute;
  padding: 7px;
  border: 1px solid #e5c982;
  background: linear-gradient(135deg, #8f6a27, #f0d791 18%, #6b4919 45%, #d8b765 76%, #77501d);
  box-shadow:
    0 16px 28px rgba(0, 0, 0, 0.38),
    0 3px 7px rgba(0, 0, 0, 0.48),
    inset 0 0 0 2px rgba(66, 39, 9, 0.55),
    inset 0 0 0 4px rgba(255, 230, 160, 0.25);
  transition: transform 0.35s ease, box-shadow 0.35s ease;

  &:hover {
    z-index: 8;
    box-shadow:
      0 24px 42px rgba(0, 0, 0, 0.5),
      0 0 28px rgba(231, 204, 132, 0.18),
      inset 0 0 0 2px rgba(66, 39, 9, 0.55),
      inset 0 0 0 4px rgba(255, 230, 160, 0.25);
  }

  &--portrait-left { left: 3%; top: 21%; width: 12%; height: 57%; transform: rotate(-1.2deg); }
  &--landscape-left { left: 18%; top: 9%; width: 22%; height: 27%; transform: rotate(0.8deg); }
  &--portrait-mid-left { left: 25%; top: 43%; width: 13%; height: 49%; transform: rotate(1.1deg); }
  &--landscape-main { left: 40.5%; top: 27%; z-index: 4; width: 29%; height: 38%; padding: 9px; }
  &--portrait-mid-right { left: 72%; top: 8%; width: 13%; height: 54%; transform: rotate(-0.8deg); }
  &--landscape-right { left: 63%; top: 69%; width: 22%; height: 24%; transform: rotate(0.9deg); }
  &--portrait-right { left: 87%; top: 27%; width: 10%; height: 48%; transform: rotate(1.4deg); }
}

.honor-frame__content {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid rgba(61, 41, 15, 0.72);
  background: #f5f0e5;
  box-shadow: inset 0 0 20px rgba(91, 66, 31, 0.22);
}

.honor-frame__image {
  width: 100%;
  height: 100%;
  background-color: #f5f0e5;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.honor-frame__placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8d6e31;
  background:
    linear-gradient(135deg, transparent 48%, rgba(160, 126, 61, 0.07) 49%, rgba(160, 126, 61, 0.07) 51%, transparent 52%),
    #f5f0e5;

  &::before,
  &::after {
    content: "";
    position: absolute;
    inset: 7%;
    border: 1px solid rgba(157, 119, 51, 0.35);
  }

  &::after { inset: 10%; border-color: rgba(157, 119, 51, 0.18); }

  strong {
    position: relative;
    z-index: 1;
    margin-top: 7px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 3px;
  }

  small {
    position: relative;
    z-index: 1;
    margin-top: 5px;
    font-size: 7px;
    letter-spacing: 2px;
    opacity: 0.62;
  }

  i {
    position: relative;
    z-index: 1;
    width: 28%;
    height: 1px;
    margin-top: 12px;
    background: linear-gradient(90deg, transparent, #a98748, transparent);
  }
}

.honor-frame__seal {
  position: relative;
  z-index: 1;
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border: 1px solid #ad3d2f;
  border-radius: 50%;
  color: #ad3d2f;
  font-family: Georgia, serif;
  font-size: 9px;
  letter-spacing: 1px;
}

.honor-frame__plate {
  position: absolute;
  left: 50%;
  bottom: 4px;
  z-index: 4;
  max-width: 82%;
  padding: 2px 8px;
  overflow: hidden;
  border: 1px solid rgba(240, 214, 145, 0.6);
  color: #f7e7ba;
  background: rgba(36, 25, 11, 0.85);
  font-size: 8px;
  letter-spacing: 1px;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform: translateX(-50%);
}

.honor-wall__counter {
  position: absolute;
  left: 4%;
  bottom: 4.5%;
  z-index: 6;
  display: flex;
  align-items: center;
  color: rgba(233, 211, 157, 0.8);

  span { font-family: Georgia, serif; font-size: 14px; }
  i { width: 34px; height: 1px; margin: 0 8px; background: rgba(233, 211, 157, 0.42); }
  small { font-size: 8px; letter-spacing: 1.4px; }
}

.certificate-fade-enter-active,
.certificate-fade-leave-active {
  transition: opacity 0.55s ease, transform 0.55s ease;
}

.certificate-fade-enter { opacity: 0; transform: scale(0.97); }
.certificate-fade-leave-to { opacity: 0; transform: scale(1.02); }

@media (max-width: 900px) {
  .honor-page-title {
    height: 72px !important;
    h1,
    h2,
    h3 { font-size: 30px !important; }
    p { font-size: 13px !important; }
  }

  .honor-wall {
    width: calc(100% - 34px);
    height: calc(100vh - 205px);
    min-height: 390px;
  }

  .honor-wall__brand { top: 3%; }

  .honor-wall__layout {
    top: 12%;
    bottom: 11%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: minmax(96px, 1fr);
    gap: 10px;
    padding: 0 12px;
  }

  .honor-frame {
    position: relative;
    inset: auto !important;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 5px;
    transform: none !important;

    &:nth-child(n + 7) { display: none; }
  }

  .honor-frame--landscape-main { grid-column: span 2; }
  .honor-frame__plate { display: none; }
  .honor-wall__counter { left: 15px; bottom: 3%; }
}


@media (max-width: 768px) {
  .home {
    width: 100%;
    overflow: hidden;
    background: #0d2c43;
  }

  #swiperBox {
    width: 100%;
    height: auto !important;
    overflow: visible;
  }

  #swiperBox ::v-deep .swiper-wrapper,
  #swiperBox ::v-deep .swiper-wrapper {
    display: block;
    width: 100%;
    height: auto !important;
    transform: none !important;
  }

  #swiperBox ::v-deep .swiper-slide,
  #swiperBox ::v-deep .swiper-slide {
    width: 100% !important;
    height: auto !important;
    min-height: 0;
  }

  #swiperBox ::v-deep .swiper-slide-duplicate,
  #swiperBox ::v-deep .swiper-slide-duplicate {
    display: none !important;
  }

  .home-swiper-pagination {
    display: none;
  }

  .swiper-slide {
    padding: 52px var(--mobile-gutter);
    justify-content: flex-start;
    background-attachment: scroll;
  }

  .slide-one {
    min-height: calc(100vh - var(--mobile-header-height)) !important;
    padding-top: clamp(92px, 24vh, 190px);
    justify-content: flex-start;
  }

  .swiper-slide .page {
    height: auto;
    overflow: visible;
  }

  .swiper-slide .page h1,
  .swiper-slide .page h2,
  .swiper-slide .page h3 {
    font-size: clamp(28px, 8vw, 36px);
    line-height: 1.2;
  }

  .swiper-slide .page p {
    margin-top: 8px;
    font-size: 14px;
  }

  .swiper-slide .slogan {
    padding: 22px 0;
    font-size: clamp(26px, 7vw, 34px);
    line-height: 1.35;
  }

  .scroll-cue {
    left: 50%;
    bottom: 24px;
    bottom: calc(24px + env(safe-area-inset-bottom));
    transform: translateX(-50%);
  }

  .scroll-cue--mouse .mouse {
    display: none;
  }

  p.mousep {
    position: static;
    width: auto;
    min-width: 88px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    letter-spacing: 2px;
    transform: none;
  }

  .slide-two .scroll-cue,
  .slide-three .scroll-cue {
    display: none;
  }

  .slide-two {
    padding-top: 42px;
    padding-bottom: 48px;
  }

  .case-item {
    display: grid;
    width: 100%;
    height: auto;
    margin: 24px auto 0;
    overflow: visible;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .case-item li {
    width: 100%;
    margin: 0;
    border-radius: 12px;
    box-shadow: 0 12px 24px rgba(2, 20, 34, 0.22);
  }

  .case-item__feature {
    grid-column: 1 / -1;
    grid-row: auto;
    min-height: 172px;
  }

  .case-item .case-item__product {
    grid-column: 1 / -1;
    min-height: 180px;
  }

  .case-item__mall {
    min-height: 218px;
  }

  .case-card--mall .case-card__info--tall {
    padding: 40px 14px 16px;
  }

  .case-item__case {
    height: 42vw;
    max-height: 190px;
    min-height: 138px;
  }

  .feature-card {
    padding: 16px 14px;
  }

  .feature-card__eyebrow {
    top: 12px;
    left: 12px;
  }

  .feature-card__icon {
    top: 14px;
    right: 12px;
    font-size: 30px;
  }

  .feature-card strong {
    font-size: 22px;
  }

  .feature-card > p {
    margin-top: 6px;
    font-size: 12px;
  }

  .feature-card__action {
    margin-top: 10px;
    font-size: 12px;
  }

  .case-card__info {
    padding: 30px 12px 12px;
    background: linear-gradient(180deg, transparent 22%, rgba(6, 30, 46, 0.9) 88%);
  }

  .case-card__title {
    font-size: 14px;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .case-card__title--lg {
    font-size: 22px;
    line-height: 1.25;
    -webkit-line-clamp: 1;
    text-shadow: 0 3px 12px rgba(0, 0, 0, 0.72);
  }

  .case-card__more {
    display: none;
  }

  .slide-three {
    padding: 42px var(--mobile-gutter) 48px;
  }

  .honor-page-title {
    height: auto !important;
    margin-bottom: 22px;
  }

  .honor-page-title h1,
  .honor-page-title h2,
  .honor-page-title h3 {
    font-size: 30px !important;
    letter-spacing: 5px;
  }

  .honor-wall {
    width: 100%;
    height: auto;
    min-height: 0;
    margin: 0 auto;
    padding: 78px 12px 54px;
    border-radius: 16px;
  }

  .honor-wall__brand {
    top: 22px;
    width: calc(100% - 24px);
  }

  .honor-wall__brand span {
    font-size: 16px;
    letter-spacing: 6px;
  }

  .honor-wall__brand small {
    font-size: 6px;
    letter-spacing: 1.5px;
  }

  .honor-wall__layout {
    position: relative;
    inset: auto;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 138px;
    gap: 10px;
    padding: 0;
  }

  .honor-frame {
    position: relative;
    inset: auto !important;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    transform: none !important;
  }

  .honor-frame--landscape-main {
    grid-column: span 2;
  }

  .honor-wall__counter {
    left: 14px;
    bottom: 18px;
  }
}

@media (max-width: 380px) {
  .case-item {
    grid-template-columns: 1fr;
  }

  .case-item__case {
    height: 52vw;
    max-height: 190px;
  }

  .case-card__desc {
    display: none;
  }

  .honor-wall__layout {
    grid-auto-rows: 122px;
  }
}

</style>
<style lang="scss" scoped>
.slide-one::before,
.slide-two::before,
.slide-three::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(circle at 75% 30%, rgba(31, 145, 199, 0.18), transparent 30%),
    linear-gradient(90deg, var(--veil-mid), rgba(4, 27, 42, 0.08) 55%, var(--veil-soft));
}

.slide-one > *,
.slide-two > *,
.slide-three > * {
  position: relative;
  z-index: 1;
}

.hero-actions {
  display: flex;
  margin-top: 2px;
  justify-content: center;
  gap: 12px;
}

.hero-action {
  display: inline-flex;
  min-width: 142px;
  min-height: 46px;
  padding: 0 22px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.46);
  border-radius: 999px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-decoration: none;
  backdrop-filter: blur(8px);
  transition: transform 0.25s var(--ease-out), background 0.25s ease, box-shadow 0.25s ease;
}

.hero-action:hover {
  transform: translateY(-2px);
}

.hero-action--primary {
  border-color: var(--brand-500);
  background: var(--brand-600);
  box-shadow: 0 12px 28px rgba(5, 74, 109, 0.34);
}

.hero-action--ghost {
  background: rgba(4, 34, 51, 0.24);
}

.hero-facts {
  display: flex;
  margin-top: 22px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.66);
  font-size: 11px;
  letter-spacing: 0.16em;
}

.hero-facts i {
  width: 30px;
  height: 1px;
  background: rgba(255, 255, 255, 0.34);
}

.home-section-link {
  position: absolute;
  right: 72px;
  bottom: 36px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 13px;
  letter-spacing: 0.08em;
  text-decoration: none;
}

.home-section-link i {
  transition: transform 0.2s ease;
}

.home-section-link:hover i {
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .slide-one::before,
  .slide-two::before,
  .slide-three::before {
    background: linear-gradient(180deg, rgba(4, 27, 42, 0.25), rgba(4, 27, 42, 0.55));
  }

  .hero-actions {
    margin-top: 6px;
    flex-wrap: wrap;
  }

  .hero-action {
    min-width: 138px;
    min-height: 44px;
    padding: 0 16px;
    font-size: 13px;
  }

  .hero-facts {
    margin-top: 18px;
    font-size: 9px;
    letter-spacing: 0.1em;
  }

  .home-section-link {
    position: static;
    margin-top: 24px;
    align-self: center;
  }
}

@media (max-width: 380px) {
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .hero-action {
    width: min(220px, 82vw);
  }
}
</style>
